var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHowToPlay4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 295,
    height: 48,
    viewBox: "0 0 295 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2162_40791)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2162_40791)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 295,
    height: 48,
    rx: 8,
    fill: "#212129"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.002,
    y: 10,
    width: 223.92,
    height: 28.8,
    rx: 5.76,
    fill: "#0012D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.769 27.8984V20.7416H129.557V21.8807H126.08V23.8362H129.376V24.9652H126.08V27.8984H124.769ZM131.806 27.8984C131.02 27.8984 130.516 27.5255 130.516 26.6284V20.7416H131.806V26.4973C131.806 26.7796 131.947 26.9005 132.209 26.9005H132.602V27.8984H131.806ZM133.409 21.8V20.6509H134.75V21.8H133.409ZM133.429 27.8984V22.5157H134.72V27.8984H133.429ZM136.215 29.4104V22.5157H137.455L137.475 23.3221C137.788 22.7173 138.372 22.3948 139.088 22.3948C140.62 22.3948 141.376 23.6548 141.376 25.2071C141.376 26.7594 140.61 28.0194 139.078 28.0194C138.392 28.0194 137.798 27.6968 137.505 27.1626V29.4104H136.215ZM138.776 26.9711C139.562 26.9711 140.036 26.3159 140.036 25.2071C140.036 24.0983 139.562 23.4431 138.776 23.4431C137.989 23.4431 137.505 24.0378 137.505 25.2071C137.505 26.3764 137.979 26.9711 138.776 26.9711ZM147.902 28.0597C145.947 28.0597 144.586 26.6687 144.586 24.3301C144.586 22.0319 145.906 20.5804 147.912 20.5804C149.737 20.5804 150.715 21.538 151.027 23.1608L149.656 23.2314C149.475 22.294 148.9 21.7194 147.912 21.7194C146.693 21.7194 145.937 22.7375 145.937 24.3301C145.937 25.9429 146.713 26.9207 147.902 26.9207C148.971 26.9207 149.535 26.3058 149.696 25.2776L151.067 25.3482C150.785 27.0316 149.707 28.0597 147.902 28.0597ZM154.402 28.0194C152.799 28.0194 151.751 26.9106 151.751 25.2071C151.751 23.5036 152.799 22.3948 154.402 22.3948C155.995 22.3948 157.043 23.5036 157.043 25.2071C157.043 26.9106 155.995 28.0194 154.402 28.0194ZM154.402 26.9711C155.229 26.9711 155.703 26.326 155.703 25.2071C155.703 24.0983 155.229 23.4431 154.402 23.4431C153.566 23.4431 153.092 24.0983 153.092 25.2071C153.092 26.326 153.566 26.9711 154.402 26.9711ZM158.019 21.8V20.6509H159.359V21.8H158.019ZM158.039 27.8984V22.5157H159.329V27.8984H158.039ZM160.825 27.8984V22.5157H161.994L162.024 23.433C162.316 22.6972 162.921 22.3948 163.637 22.3948C164.826 22.3948 165.471 23.2314 165.471 24.441V27.8984H164.181V24.8543C164.181 23.9471 163.939 23.4431 163.244 23.4431C162.548 23.4431 162.115 23.9471 162.115 24.8543V27.8984H160.825ZM168.938 28.0194C167.345 28.0194 166.519 27.2634 166.438 26.205L167.759 26.1445C167.849 26.709 168.202 27.0316 168.948 27.0316C169.543 27.0316 169.916 26.8501 169.916 26.4268C169.916 26.0639 169.724 25.9026 168.736 25.7312C167.083 25.449 166.569 25.0055 166.569 24.0882C166.569 23.0903 167.345 22.3948 168.847 22.3948C170.299 22.3948 171.045 23.1709 171.186 24.2092L169.885 24.2696C169.795 23.7253 169.432 23.3826 168.827 23.3826C168.222 23.3826 167.91 23.6548 167.91 24.0479C167.91 24.4813 168.192 24.6527 169.008 24.7837C170.702 25.0458 171.246 25.5095 171.246 26.4066C171.246 27.4448 170.319 28.0194 168.938 28.0194Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.429 31.3048L240.179 29.7958M240.179 29.7958L237.553 28.0346C236.93 27.6172 236.764 26.7753 237.18 26.154C237.597 25.5327 238.439 25.3675 239.061 25.7849L243.155 28.5296M240.179 29.7958L239.67 30.5991C239.326 31.1408 239.307 31.7977 239.564 32.3397M243.155 28.5296L246.572 30.8216M243.155 28.5296L246.525 27.9733C248.713 27.7335 249.318 29.0363 249.593 29.8509L250.608 32.2848C251.541 34.2408 251.414 35.6947 250.815 36.5878L248.364 40.2437C247.225 41.9411 244.38 42.3272 242.744 41.2304L238.825 38.6545C238.063 38.1541 237.793 37.1662 238.194 36.3499L238.826 35.101M239.564 32.3397C239.699 32.6243 239.911 32.8773 240.191 33.0653L240.943 33.5696M239.564 32.3397L238.934 33.3676C238.41 34.1938 238.642 35.2879 239.456 35.8338L240.208 36.3381",
    stroke: "white",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2162_40791",
    x: -1,
    y: 0,
    width: 296,
    height: 49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2162_40791"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2162_40791"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 295,
    height: 48,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowToPlay4);
export default __webpack_public_path__ + "static/media/howToPlay4.911aac40cd586bc6d4e94c3b4191cac9.svg";
export { ForwardRef as ReactComponent };